import React, { useMemo, useState } from 'react';
import Header from './Header';
import BaseUrl from '../BaseUrl';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import Footer from './Footer';
import './style.css';

const bubbles = [
  { size: 260, left: '6%', top: '10%', opacity: 0.12, blur: 52, dur: 28, delay: -4 },
  { size: 180, left: '78%', top: '14%', opacity: 0.11, blur: 44, dur: 32, delay: -12 },
  { size: 120, left: '42%', top: '22%', opacity: 0.1, blur: 36, dur: 24, delay: -8 },
  { size: 200, left: '12%', top: '58%', opacity: 0.09, blur: 48, dur: 34, delay: -18 },
  { size: 140, left: '82%', top: '62%', opacity: 0.1, blur: 38, dur: 26, delay: -14 },
];

const dots = [
  { s: 3, l: '18%', t: '28%', o: 0.12, d: 28, dl: -6 },
  { s: 2, l: '72%', t: '34%', o: 0.1, d: 32, dl: -14 },
  { s: 3, l: '52%', t: '72%', o: 0.1, d: 34, dl: -18 },
];

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({ email: '' });
  const navigate = useNavigate();

  const primaryGradient = useMemo(
    () => ({
      backgroundImage: 'linear-gradient(90deg, #00C6FF 0%, #009BFF 40%, #0072FF 100%)',
    }),
    []
  );

  const handleValidation = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setErrors({ email: 'Invalid email address' });
      return false;
    }
    setErrors({ email: '' });
    return true;
  };

  const sendOtp = async (e) => {
    e.preventDefault();
    if (!handleValidation()) return;

    const url = BaseUrl() + 'api/user/send-otp';
    const data = { email };

    try {
      const response = await axios.post(url, data);
      console.log(response);
      if (response.status === 200) {
        localStorage.setItem('authorization', response.data.temptoken);
        navigate('/otp-verify', {
          state: { data: response.data, email },
        });
      } else {
        swal(response.data.message);
      }
    } catch (error) {
      swal('No account found with this email address.');
    }
  };

  const inputRing =
    'min-h-[48px] rounded-[12px] border border-black/10 bg-white/70 py-2.5 pl-12 text-[15px] leading-snug text-slate-800 shadow-[0_1px_3px_rgba(15,23,42,0.07)] outline-none transition-all duration-200 ease-out placeholder:text-slate-500 hover:border-black/[0.16] hover:bg-white/[0.78] hover:shadow-[0_2px_6px_rgba(15,23,42,0.06)] focus:border-cyan-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(0,200,255,0.2)]';

  const btnPrimary =
    'w-full rounded-full py-3.5 text-base font-bold text-white shadow-[0_14px_38px_rgba(0,114,255,0.38)] transition duration-300 hover:scale-[1.02] hover:brightness-110 hover:shadow-[0_20px_48px_rgba(0,198,255,0.42)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-60';

  return (
    <div className="relative flex min-h-screen flex-col bg-[#F4FEFF]">
      <div className="relative z-20 shrink-0">
        <Header />
      </div>

      <main className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage: [
              'linear-gradient(105deg, #CCF4FF 0%, #E8FBFF 28%, #FFFFFF 55%, #E6F4FF 100%)',
              'radial-gradient(620px 420px at 50% 48%, rgba(0,198,255,0.28), transparent 68%)',
              'radial-gradient(720px 480px at 92% 24%, rgba(0,114,255,0.09), transparent 72%)',
            ].join(','),
          }}
        />

        {bubbles.map((b, i) => (
          <span
            key={i}
            className="bsi-bubble pointer-events-none absolute"
            style={{
              width: b.size,
              height: b.size,
              left: b.left,
              top: b.top,
              opacity: b.opacity,
              filter: `blur(${b.blur}px)`,
              animationDuration: `${b.dur}s`,
              animationDelay: `${b.delay}s`,
            }}
          />
        ))}

        <div className="pointer-events-none absolute inset-0">
          {dots.map((p, i) => (
            <span
              key={i}
              className="bsi-cta-dot"
              style={{
                width: `${p.s}px`,
                height: `${p.s}px`,
                left: p.l,
                top: p.t,
                opacity: p.o,
                animationDuration: `${p.d}s`,
                animationDelay: `${p.dl}s`,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 py-10 sm:py-12 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:py-14 xl:gap-14">
          <aside className="mb-10 hidden max-w-md flex-shrink-0 lg:mb-0 lg:flex lg:flex-col lg:justify-center">
            <div className="relative">
              <div className="absolute -left-10 top-1/2 h-52 w-52 -translate-y-1/2 rounded-full bg-cyan-300/35 blur-3xl" />
              <div className="absolute -right-6 top-6 h-36 w-36 rounded-full bg-[#0072FF]/22 blur-3xl" />
              <div className="relative rounded-[28px] border border-white/85 bg-white/55 p-8 shadow-[0_28px_90px_rgba(2,132,199,0.16)] backdrop-blur-xl">
                <div
                  className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-[0_14px_34px_rgba(0,114,255,0.28)]"
                  style={primaryGradient}
                >
                  <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 16v-4" />
                    <path d="M12 8h.01" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold tracking-tight text-[#0F172A]">Reset your password</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#64748B]">
                  We&apos;ll email you a secure link to verify it&apos;s you—quick, calm, and straightforward.
                </p>
              </div>
            </div>
          </aside>

          <div className="relative w-full max-w-[440px] shrink-0 lg:max-w-[420px]">
            <div className="pointer-events-none absolute -inset-3 rounded-[28px] bg-gradient-to-br from-cyan-300/45 via-white/10 to-blue-400/35 opacity-90 blur-2xl" />
            <div className="pointer-events-none absolute inset-x-10 -bottom-8 h-28 rounded-full bg-cyan-400/20 blur-2xl" />
            <form
              onSubmit={sendOtp}
              className="relative rounded-[24px] border border-white/80 bg-[rgba(255,255,255,0.68)] p-8 shadow-[0_32px_100px_rgba(2,132,199,0.18)] backdrop-blur-xl sm:p-10"
            >
              <div className="mb-8 text-center lg:text-left">
                <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] sm:text-[26px]">Forgot Password</h1>
                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">
                  Enter the email associated with your account and we&apos;ll send you a one-time code.
                </p>
              </div>

              <div className="space-y-7">
                <div>
                  <label htmlFor="fp-email" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                    Email
                  </label>
                  <div className="relative">
                    <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                    </span>
                    <input
                      id="fp-email"
                      type="email"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors({ email: '' });
                      }}
                      placeholder="you@company.com"
                      className={`${inputRing} w-full pr-4 ${
                        errors.email
                          ? 'border-red-400/80 focus:border-red-400 focus:shadow-[0_0_0_3px_rgba(248,113,113,0.22)]'
                          : ''
                      }`}
                    />
                  </div>
                  {errors.email && <p className="mt-1.5 text-sm text-red-600">{errors.email}</p>}
                </div>

                <button type="submit" style={primaryGradient} className={btnPrimary}>
                  Send OTP
                </button>
              </div>

              <p className="mt-8 text-center text-sm text-[#64748B]">
                Remember your password?{' '}
                <Link to="/login" className="font-bold text-cyan-700 underline-offset-4 transition hover:text-cyan-900 hover:underline">
                  Sign In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </main>

      <div className="relative z-20 mt-auto shrink-0">
        <Footer />
      </div>
    </div>
  );
}
